module.exports = __webpack_public_path__ + "img/6f_l_okura.40614e2d.png";